import React from 'react'
import {Container, Tabs, Tab} from 'react-bootstrap'
import Akun from './comp_main/akun'
import Transaksi from './comp_main/transaksi'
import Alamat from './comp_main/alamat'
// REM import Tentang from './comp_main/tentang'
import './style.css'

export default function main() {
    return (
        <Container className="main-user">
            <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example" className="mb-3">
            <Tab eventKey="akun" title="Akun">
                <Akun />
            </Tab>
            <Tab eventKey="transaksi" title="Transaksi">
                <Transaksi />
            </Tab>
            <Tab eventKey="alamat" title="Alamat">
                <Alamat />
            </Tab>
        </Tabs>
        </Container>
    )
}
